<div
  class="ui-chart-element__value"
  [matTooltip]="tooltip"
  [matTooltipPosition]="orientation === 'horizontal' ? 'right' : 'above'"
  matTooltipClass="ui-chart-element__tooltip"
  [ngClass]="colorClass"
  [ngStyle]="orientation === 'horizontal' ? { width: value + '%' } : { height: value + '%' }"
>
</div>
